import { IController, IWindowService } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { SdcWizardStepperService } from '../../../../../shared/services/sdc/sdc-wizard-stepper.service';
import { ISdcStore } from './../../../../../sdc/flux/sdc-store.interface';

const sdcKey = 'credit-gaps';

export class CreditGapsTransferStepperCtrl implements IController {
  static $inject: string[] = ['$scope', 'SDCStore', 'SdcWizardStepperService', '$window', 'ImSchool'];

  // bindings
  public stepper: any;
  public uiReady: boolean = false;
  public selectedGradDate: string;
  public courseDiffs;

  // class properties
  constructor(
    private $scope,
    private SDCStore: ISdcStore,
    private SdcWizardStepperService: SdcWizardStepperService,
    private $window: IWindowService,
    private ImSchool: ImSchool,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.setListeners();
        this.$window.setTimeout(() => this.SdcWizardStepperService.init(sdcKey));
      }
    });
  }

  setUi(): void {
    const currentSdcFilter = this.SDCStore.getFilter();
    const nextFourGradDates = this.ImSchool.getNextFourGradDatesForTransfer();
    const lastTerm: any = _.last(nextFourGradDates);
    const graduationDateFilter = currentSdcFilter.plannedGraduationDate;

    if (graduationDateFilter) {
      this.selectedGradDate =
        graduationDateFilter.length > 1 ? `Planned Beyond ${lastTerm.humanName} Grad` : graduationDateFilter.toString();
    } else this.selectedGradDate = null;
    this.uiReady = true;
  }

  private setListeners(): void {
    this.$scope.$listenTo(this.SDCStore, ['filteredFlattenedStudents'], this.setUi.bind(this));
  }

  prevStep = this.SdcWizardStepperService.back;
  nextStep = this.SdcWizardStepperService.next;
}
